<button (click)='goToMainContent()'
        tabindex='0'
        role='link'
        class='skip-link'>{{ 'app.goToMainContent' | translate }}</button>
<div class='flex-100 flex-column app-container'>
  <video-tutorial *plIfCan='"actAsTeacher"'></video-tutorial>
  <div class='flex app-wrapper'>
    <router-outlet></router-outlet>
  </div>
  @if (consoleStyle) {
    <debug-console [style]='consoleStyle'
                   (expandSelected)='expandConsole()'
                   (closeSelected)='closeConsole()'
                   (collapseSelected)='collapseConsole()'>
    </debug-console>
  }
</div>
<lesson-generation-snackbars />
